module.exports = __webpack_public_path__ + "assets/icomoon.28dd4b95.ttf";